import { REQUEST_FACEBOOK_POST_LIST_SUCCESS, REQUEST_FACEBOOK_POST_LIST_FAILURE, REQUEST_FACEBOOK_PAGE_INITIAL_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function facebookPagePostList(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_FACEBOOK_POST_LIST_SUCCESS:
      
       let tempdata = state.data;
      
     
  

//{ data: action.payload.data.data, errors: null }
let tempConcat = tempdata.concat(action.payload.data);
      return { data: tempConcat, errors: null };


      case REQUEST_FACEBOOK_POST_LIST_FAILURE:


      return { data: [], errors: action.payload.response && action.payload.response.data.errors };
    
      
      case REQUEST_FACEBOOK_PAGE_INITIAL_SUCCESS:

      return { data: action.payload.data, errors: null }
      // return { data: action.payload, errors: null }
    
      default:
      return state;
  }
}
